import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../context/AuthContext';

/** Staff panels (driver / operator) — matches SmartGaz zip RoleHeader + full-height stage */
export function RoleHeader({ role, right }) {
  const { logout } = useAuth();
  const { t } = useTranslation();

  return (
    <header className="sticky top-0 z-30 h-[62px] flex items-center justify-between px-5 bg-white/92 backdrop-blur-xl border-b border-[var(--border)]">
      <div className="flex items-center gap-2.5">
        <div className="h-9 w-9 rounded-[11px] bg-gradient-to-br from-[#1e9f6b] to-[#0d7a52] flex items-center justify-center shadow-[0_10px_25px_rgba(30,159,107,0.3)]">
          <span className="material-symbols-outlined text-white text-[20px]" style={{ fontVariationSettings: "'FILL' 1" }}>local_gas_station</span>
        </div>
        <div className="leading-tight">
          <div className="sg-wordmark text-lg">Smart<em>Gaz</em></div>
          <div className="text-[9px] font-black uppercase tracking-[0.16em] text-[var(--fg4)]">{role}</div>
        </div>
      </div>
      <div className="flex items-center gap-3">
        {right}
        <button
          type="button"
          onClick={logout}
          className="hidden sm:flex items-center gap-2 px-3 py-2 rounded-xl text-xs font-bold text-[var(--fg3)] hover:bg-[var(--bg-subtle)] transition-colors"
        >
          <span className="material-symbols-outlined text-[18px]">logout</span>
          {t('profileModal.logout')}
        </button>
      </div>
    </header>
  );
}

export function RolePageLayout({ role, headerRight, children, className = '' }) {
  return (
    <div className={`min-h-screen flex flex-col bg-[var(--bg-app-admin)] ${className}`}>
      <RoleHeader role={role} right={headerRight} />
      <main className="flex-1 overflow-y-auto">{children}</main>
    </div>
  );
}

export function RoleWordmarkLink() {
  return (
    <Link to="/" className="sg-wordmark text-lg no-underline">
      Smart<em>Gaz</em>
    </Link>
  );
}
